import { AppSubNav } from "@components/widgets/AppSubNav/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import Planning from "@src/components/modules/planning/timeline";
import { FullScreenContainer } from "@src/components/ui-kit";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    fullWidth
    noGutters
    noTopMargin
    noBottomMargin
    title={t`Planning`}
    navigation={<AppSubNav />}
  >
    <DemoModule module={Modules.ResourcePlanning}>
      <FullScreenContainer heightOffset="-4rem" noBottomMargin>
        <Planning />
      </FullScreenContainer>
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/old-planning/")({
  component: Page,
});
